// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TeamMembers_sectionTitle__EA6BQ {
  font-size: var(--font-size-larger);
  margin-bottom: calc(var(--gutter) * 2);
  color: var(--color-text);
}

.TeamMembers_memberCard__BL2Vs {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
}

.TeamMembers_memberCardInner__wuX61 {
  display: flex;
  flex-direction: column;
  gap: calc(var(--gutter) * 0.5);
}

.TeamMembers_memberAvatar__6r8oD {
  margin-bottom: 0.5rem;
}

.TeamMembers_memberBadges__vSSY7 {
  display: flex;
  align-items: center;
  gap: calc(var(--gutter) * 0.25);
}

.TeamMembers_adminBadge__HAfDe,
.TeamMembers_userBadge__HomHk {
  display: inline-block;
  background-color: var(--color-surface-darker);
  color: var(--color-text);
  padding: calc(var(--gutter) * 0.25) calc(var(--gutter) * 0.25);
  border-radius: var(--radius-small);
  font-size: var(--font-size-smaller);
  line-height: var(--font-size-smaller);
  font-weight: 500;
}

.TeamMembers_teamMemberBadge__l1G66,
.TeamMembers_departmentBadge__RRzeU {
  display: inline-block;
  background-color: var(--color-surface);
  color: var(--color-text);
  padding: calc(var(--gutter) * 0.25) calc(var(--gutter) * 0.25);
  border-radius: var(--radius-small);
  font-size: var(--font-size-smaller);
  line-height: var(--font-size-smaller);
  font-weight: 500;
}

.TeamMembers_memberCardContent__b8NMo {
  margin-bottom: 1rem;
}

.TeamMembers_roleInfo__iNjJS {
  margin-top: 0.25rem;
  color: var(--color-text-lighter);
  font-size: 0.9rem;
}

.TeamMembers_editNote__j26MX {
  margin: 0.5rem 0;
  color: var(--color-text-lighter);
  font-size: 0.85rem;
  font-style: italic;
}

.TeamMembers_roleSelector__cG88W {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-surface-lighter);
  border-radius: var(--radius-default);
  width: 100%;
}
.TeamMembers_roleSelector__cG88W .TeamMembers_selfRoleNote__degRZ {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: var(--color-text-lighter);
  font-style: italic;
}

.TeamMembers_modalUserInfo__USX41 {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--color-border);
}
.TeamMembers_modalUserInfo__USX41 h3 {
  margin: 0 0 0.25rem 0;
  font-size: 1.1rem;
}
.TeamMembers_modalUserInfo__USX41 p {
  margin: 0 0 0.5rem 0;
  color: var(--color-text-lighter);
}
.TeamMembers_modalUserInfo__USX41 .TeamMembers_memberBadges__vSSY7 {
  margin-top: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/TeamMembers.module.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,sCAAA;EACA,wBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,+BAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,6CAAA;EACA,wBAAA;EACA,8DAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,sCAAA;EACA,wBAAA;EACA,8DAAA;EACA,kCAAA;EACA,mCAAA;EACA,qCAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gCAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8CAAA;EACA,oCAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AACJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,oBAAA;EACA,4CAAA;AADF;AAGE;EACE,qBAAA;EACA,iBAAA;AADJ;AAIE;EACE,oBAAA;EACA,gCAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ","sourcesContent":[".sectionTitle {\n  font-size: var(--font-size-larger);\n  margin-bottom: calc(var(--gutter) * 2);\n  color: var(--color-text);\n}\n\n.memberCard {\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  gap: var(--gutter);\n}\n\n.memberCardInner {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--gutter) * 0.5);\n}\n\n.memberAvatar {\n  margin-bottom: .5rem;\n}\n\n.memberBadges {\n  display: flex;\n  align-items: center;\n  gap: calc(var(--gutter) * 0.25);\n}\n\n.adminBadge,\n.userBadge {\n  display: inline-block;\n  background-color: var(--color-surface-darker);\n  color: var(--color-text);\n  padding:  calc(var(--gutter) * 0.25) calc(var(--gutter) * 0.25);\n  border-radius: var(--radius-small);\n  font-size: var(--font-size-smaller);\n  line-height: var(--font-size-smaller);\n  font-weight: 500;\n}\n\n.teamMemberBadge,\n.departmentBadge {\n  display: inline-block;\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  padding:  calc(var(--gutter) * 0.25) calc(var(--gutter) * 0.25);\n  border-radius: var(--radius-small);\n  font-size: var(--font-size-smaller);\n  line-height: var(--font-size-smaller);\n  font-weight: 500;\n}\n\n.memberCardContent {\n  margin-bottom: 1rem;\n}\n\n.roleInfo {\n  margin-top: 0.25rem;\n  color: var(--color-text-lighter);\n  font-size: 0.9rem;\n}\n\n.editNote {\n  margin: 0.5rem 0;\n  color: var(--color-text-lighter);\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.roleSelector {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: var(--color-surface-lighter);\n  border-radius: var(--radius-default);\n  width: 100%;\n  \n  .selfRoleNote {\n    margin-top: 0.5rem;\n    font-size: 0.75rem;\n    color: var(--color-text-lighter);\n    font-style: italic;\n  }\n}\n\n// Modal user info styles\n.modalUserInfo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--color-border);\n  \n  h3 {\n    margin: 0 0 0.25rem 0;\n    font-size: 1.1rem;\n  }\n  \n  p {\n    margin: 0 0 0.5rem 0;\n    color: var(--color-text-lighter);\n  }\n  \n  .memberBadges {\n    margin-top: 0.5rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionTitle": `TeamMembers_sectionTitle__EA6BQ`,
	"memberCard": `TeamMembers_memberCard__BL2Vs`,
	"memberCardInner": `TeamMembers_memberCardInner__wuX61`,
	"memberAvatar": `TeamMembers_memberAvatar__6r8oD`,
	"memberBadges": `TeamMembers_memberBadges__vSSY7`,
	"adminBadge": `TeamMembers_adminBadge__HAfDe`,
	"userBadge": `TeamMembers_userBadge__HomHk`,
	"teamMemberBadge": `TeamMembers_teamMemberBadge__l1G66`,
	"departmentBadge": `TeamMembers_departmentBadge__RRzeU`,
	"memberCardContent": `TeamMembers_memberCardContent__b8NMo`,
	"roleInfo": `TeamMembers_roleInfo__iNjJS`,
	"editNote": `TeamMembers_editNote__j26MX`,
	"roleSelector": `TeamMembers_roleSelector__cG88W`,
	"selfRoleNote": `TeamMembers_selfRoleNote__degRZ`,
	"modalUserInfo": `TeamMembers_modalUserInfo__USX41`
};
export default ___CSS_LOADER_EXPORT___;
